// src/components/SEOHelmet.js
import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import constant from '../../constants/Constatnt';

const SEOHelmet = ({ title, description, keywords, robots }) => {
  return (
    <Helmet>
      {/* Dynamic title */}
      <title>{title ? `${title} | ${constant.seoWebsiteName}` : `Official Website`}</title>

      {/* Meta Description */}
      <meta
        name="description"
        content={description || `Welcome to ${constant.seoWebsiteName} – Your trusted online sports betting club with instant withdrawals and 24/7 support.`}
      />

      {/* Keywords */}
      {keywords && <meta name="keywords" content={keywords || `${constant.seoWebsiteName} Download Latest Version, ${constant.seoWebsiteName} Customer Care Number, ${constant.seoWebsiteName} Contact Number, ${constant.seoWebsiteName} Login, ${constant.seoWebsiteName} app download, ${constant.seoWebsiteName} betting app, ${constant.seoWebsiteName} online betting, ${constant.seoWebsiteName} live casino, ${constant.seoWebsiteName} cricket betting, Online Betting ID, Online Cricket ID`} />}

      {/* Robots (indexing instruction) */}
      <meta name="robots" content={robots || "index, follow"} />

      {/* Canonical URL (optional, good for SEO) */}
      {/* <link rel="canonical" href={window.location.href} /> */}

      {/* Social Sharing: Open Graph tags */}
      <meta property="og:title" content={title || `${constant.seoWebsiteName} - Official Website`} />
      <meta property="og:description" content={description || `Join ${constant.seoWebsiteName} for premium online sports betting`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="%PUBLIC_URL%/og-image.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
    </Helmet>
  );
};

SEOHelmet.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  robots: PropTypes.string,
};

export default SEOHelmet;